import { render } from "./NewWheel.vue?vue&type=template&id=31493f3e"
import script from "./NewWheel.vue?vue&type=script&lang=js"
export * from "./NewWheel.vue?vue&type=script&lang=js"

import "./NewWheel.vue?vue&type=style&index=0&id=31493f3e&lang=scss"

import exportComponent from "/Users/bahramhasanov/Downloads/_TRASH/loyalty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__